import { BodyText, InlineEdit } from '@servicetitan/design-system';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import formatAddress from '@lib/utils/formatAddress';
import { userE911AddressState } from '@modules/E911AddressModule/store';

export const E911AddressBar: React.FC = () => {
  const navigate = useNavigate();

  const getContent = () => {
    if (userE911AddressState.e911Address) {
      return (
        <BodyText size='small'>
          {formatAddress(userE911AddressState.e911Address)}
        </BodyText>
      );
    } else {
      return (
        <BodyText subdued size='small'>
          Add E911 Address
        </BodyText>
      );
    }
  };

  return (
    <InlineEdit
      showContentOnEdit
      content={getContent}
      decoration={{ color: false, underline: false }}
      actionLayout='none'
      control={function noRefCheck() {}}
      onClick={() =>
        navigate('/personalsettings', {
          state: { addressEditorOpen: true },
        })
      }
    />
  );
};
